module.exports = __webpack_public_path__ + "static/media/fvs_valve1_33.987ae169.jpg";